import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useEpdOrderTabQuery = (uid: string) =>
  useQuery({
    queryKey: ['epd', 'order', uid],
    queryFn: () => Api.orders.getEpdOrderTab(uid),
    enabled: !!uid,
  });
